import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles } from "./adminStyles";

const TickerTab = ({ profile, currentUserName }) => {
  const [tickerMode, setTickerMode] = useState("prices");
  const [tickerText, setTickerText] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/admin/ticker-settings?profile=${profile}`);
        setTickerMode(res.data.mode || "prices");
        setTickerText(res.data.custom_text || "");
      } catch (e) { console.error(e); }
    };
    load();
  }, [profile]);

  const saveTickerSettings = async () => {
    try {
      await axios.post(`${API}/admin/ticker-settings?profile=${profile}`, { mode: tickerMode, custom_text: tickerText });
      setSuccess("Kayar band ayarlari kaydedildi!");
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Kayar band ayarlari kaydedilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center', padding: '30px 20px'}}>
      <div style={styles.panel}>
        <h1 style={styles.title}>Kayar Band Ayarlari - {currentUserName}</h1>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ color: '#09301E', marginBottom: '12px', fontSize: '16px' }}>Band Icerigi</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <label
              style={{
                display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 16px',
                backgroundColor: tickerMode === 'prices' ? '#DA9F54' : '#f5f5f5',
                color: tickerMode === 'prices' ? '#000' : '#333',
                borderRadius: '10px', cursor: 'pointer', border: tickerMode === 'prices' ? '2px solid #b8860b' : '2px solid #ddd',
                fontWeight: 'bold', fontSize: '15px', transition: 'all 0.2s'
              }}
              data-testid="ticker-mode-prices"
            >
              <input type="radio" name="tickerMode" value="prices" checked={tickerMode === 'prices'} onChange={() => setTickerMode('prices')} style={{ width: '18px', height: '18px', accentColor: '#09301E' }} />
              Fiyatlari Goster (Varsayilan)
            </label>
            <label
              style={{
                display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 16px',
                backgroundColor: tickerMode === 'custom' ? '#DA9F54' : '#f5f5f5',
                color: tickerMode === 'custom' ? '#000' : '#333',
                borderRadius: '10px', cursor: 'pointer', border: tickerMode === 'custom' ? '2px solid #b8860b' : '2px solid #ddd',
                fontWeight: 'bold', fontSize: '15px', transition: 'all 0.2s'
              }}
              data-testid="ticker-mode-custom"
            >
              <input type="radio" name="tickerMode" value="custom" checked={tickerMode === 'custom'} onChange={() => setTickerMode('custom')} style={{ width: '18px', height: '18px', accentColor: '#09301E' }} />
              Ozel Yazi Goster
            </label>
          </div>
        </div>

        {tickerMode === 'custom' && (
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ color: '#09301E', marginBottom: '8px', fontSize: '15px' }}>Ozel Yazi</h3>
            <textarea
              value={tickerText}
              onChange={(e) => setTickerText(e.target.value)}
              placeholder="Kayar bandda gosterilecek yaziyi girin..."
              style={{ width: '100%', padding: '14px', fontSize: '15px', border: '2px solid #09301E', borderRadius: '10px', minHeight: '100px', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }}
              data-testid="ticker-custom-text-input"
            />
            <p style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>Bu yazi kayar bandda surekli tekrar ederek kayacaktir.</p>
          </div>
        )}

        <button onClick={saveTickerSettings} style={styles.saveButton} data-testid="save-ticker-btn">Kaydet</button>
        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={styles.backButton}>Fiyat Sayfasina Don</button>
      </div>
    </div>
  );
};

export default TickerTab;
